export default "__VITE_ASSET__baa1551f__"